import React from 'react';
import { connectToStore } from './store';
//import ActiveItem from './components/ActiveItem';

function App() {
	return (
		<div style={{ display: `flex`, height: `100vh` }}>
			<div style={{ padding: 12, justifyContent: `center`, display: `flex`, flexDirection: `column` }}>
				<span
					style={{ textAlign: `center` }}
				>{`You are trying to reach an older version of the Wellbeing questionnaire. Sadly it's not supported anymore.`}</span>
				<div style={{ marginBottom: 8 }} />
				<span
					style={{ textAlign: `center` }}
				>{`Please update the app to the latest version in order to proceed with the up to date questionnaire.`}</span>
			</div>
		</div>
	);
}

export default connectToStore(App);
